
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wer täglich mehrere Tassen Kaffee gewohnt ist und an Migräne leidet, bekommt
häufig Schmerzanfälle, wenn er den Kaffee weglässt. Ein Übergebrauch, also mehr
als circa fünf Tassen pro Tag, kann die Migränehäufigkeit erhöhen. Das gilt auch
für koffeinhaltige Getränke. Kaffee sollte regelmässig oder gar nicht getrunken
werden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;